import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyBO7LCPzwHTzvfHFV-5QG8N10lx7bwdKic",
  authDomain: "gem-app-ad590.firebaseapp.com",
  projectId: "gem-app-ad590",
  storageBucket: "gem-app-ad590.firebasestorage.app",
  messagingSenderId: "451091699223",
  appId: "1:451091699223:web:6fa88d6e942af78ba5ae52",
  measurementId: "G-85KX5E0XLX",
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export const app_analytics = getAnalytics(app);
export { messaging };
